import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { HelperService } from "../../services/helper.service";
import { MapDesignationService } from "../../services/mapdesignation.service";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

import { AssessmentService } from "../../services/assessment.service";
import { ObjectivesService } from "../../services/objectives.service";
import { DesignationMasterService } from "../../services/designation-master.service";
import { RilrService } from "../../services/rilr.service";
import { IOption } from "ng-select";

@Component({
  selector: "app-create-new-objectives-designation.component",
  templateUrl: "./create-new-objectives-designation.component.html",
  providers: [ObjectivesService, RilrService],
})
export class CreateNewObjectivesDesignations implements OnInit {
  @Input() id: number;
  @Input() type: number;
  assCategories: any;
  assElements: any;
  assCompEle: any;
  templateList: any;
  designationList: any;
  designationsOnly: any;

  @Output() dataToEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("swalModalUpdateMapDesig") swalModalUpdateMapDesig: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  companySystemID = +this.helperService.getSelectedCompanyId();
  Designations: any = [];

  public employeeOption: Array<IOption> = [];
  public isEdit: number;
  public formData: any = {};

  constructor(
    private formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private objectivesService: ObjectivesService,
    private assessmentService: AssessmentService,
    private designationMasterService: DesignationMasterService,
    private rilrService: RilrService,
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  public getFormData() {
    const that = this;
    this.designationMasterService
      // .getTemplateEmployeesFormData()
      .getAllEmployeesFormData()
      .get({
        companyId: +that.helperService.getSelectedCompanyId(),
        // type: "create",
      })
      .subscribe(
        (data) => {
          const resp = data.data.data;
          //console.log(resp);
          that.assCategories = that.helperService.setSelect2DropDownOptions(
            resp.assCategories,
            "auto_id",
            "code"
          );
          that.assElements = that.helperService.setSelect2DropDownOptions(
            resp.assElements,
            "auto_id",
            "description"
          );
          that.assCompEle = that.helperService.setSelect2DropDownOptions(
            resp.assCompEle,
            "auto_id",
            "description"
          );
          that.templateList = that.helperService.setSelect2DropDownOptions(
            resp.objctiveTemplateList,
            "auto_id",
            "code"
          );
          that.designationList = that.helperService.setSelect2DropDownOptions(
            resp.designationCategories,
            "id",
            "designationCategory"
          );
          that.designationsOnly = that.helperService.setSelect2DropDownOptions(
            resp.designations,
            "designationID",
            "designation"
          );
          //console.log(that.designationList);
          //console.log(that.designationsOnly);
        },
        (error) => {}
      );
  }


  public typehead(value: any): void {
    if (value.length > 2) {
      this.getEmployees(value);
    } else {
      this.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
          if (that.isEdit == 1) {
            setTimeout(() => {
              that.formData.assessor_id =
                that.helperService.setSelectedValue(
                  that.formData.assessor_id
                );
            }, 0);
          }
        },
        (err) => {
          //console.log(err);
          that.employeeOption = [];
        }
      );
  }



  ngOnInit() {
    this.id = Number(localStorage.getItem("create-objective-designation-auto_id"));
    localStorage.removeItem("create-objective-designation-auto_id");

    this.type = Number(localStorage.getItem("create-objective-designation-type"));
    localStorage.removeItem("create-objective-designation-type");

    //console.log(this.id);
    //console.log(this.type);

    this.getFormData();
  }



  addNewObjDesig(formData: any) {
    const requestData = {
      master_id: this.id,
      desig_cat_id: formData.desig_cat_id,
      desig_name_id: formData.desig_name_id,
      assessor_id: formData.assessor_id,
      company_id: this.companySystemID,
      added_des_type: this.type,
    };
    //console.log(requestData);

    let that = this;
    that.objectivesService.addNewObjDesig()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          //console.log(resp);
          that.successMsg = "Successfully added a new designation.";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "Already added this designation.";
          if (error.status == 500) {
            that.htmlErrorMessage = "Already added this designation.";
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
            that.showErrorHtml();
          }
          this.tableReload.emit();
        }
      );
  }
















}



// WEBPACK FOOTER //
// /app/src/app/competancy/create-new-objectives-designation/create-new-objectives-designation.component.ts